import { LeadReferrerArrangement } from './referrer-arrangement';

export namespace LeadReferrer {
  export interface ReferrerIdModel {
    referrerId: string | null;
  }
  export interface LendingPartnerModel {
    lendingPartner: LeadReferrerArrangement.Model;
  }
  export type SchemaContract =
    | {
        lendingPartner: LeadReferrerArrangement.SchemaContract;
      }
    | {
        referrerId: string | null;
      }
    | null;

  export type Model = LendingPartnerModel | ReferrerIdModel | null;

  export namespace Model {
    export function isLendingPartner(
      value: Model
    ): value is LendingPartnerModel {
      return !!value && 'lendingPartner' in value;
    }
    export function isReferrerId(value: Model): value is ReferrerIdModel {
      return !!value && 'referrerId' in value;
    }
  }

  export function toSchemaContract(r: Model | null): SchemaContract {
    if (!r) {
      return null;
    }

    if ('referrerId' in r) {
      return {
        referrerId: r.referrerId
      };
    }

    return {
      lendingPartner: LeadReferrerArrangement.toSchemaContract(r.lendingPartner)
    };
  }

  export function toModel(r: SchemaContract): Model | null {
    if (!r) {
      return null;
    }

    if ('referrerId' in r) {
      return {
        referrerId: r.referrerId
      };
    }

    const lendingPartner = LeadReferrerArrangement.toModel(r.lendingPartner);

    return lendingPartner
      ? {
          lendingPartner
        }
      : null;
  }
}
